module.exports = __webpack_public_path__ + "img/pageIndex_bg.1bc9e632.png";